import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the external api management
 */
export class APIService extends BaseService {
	
	constructor() {	
		super();
	}
		
	//api restriction policy
	async getAPIRestrictions(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/api-restriction-policies' + params);		
		return data;
	}	
	
	async getAPIRestriction(policyId) {	
		var result = await this.makePUTRequest('/api/resource/api-restriction-policies/' + policyId);
		return result;
	}		
	
	async deleteAPIRestriction(policyId) {
		var data = await this.makeDELETERequest('/api/resource/api-restriction-policies/' + policyId);		
		return data;		
	}	
	
	async getAPIRestrictionCompanies() {	
		var result = await this.makeGETRequest('/api/resource/api-restriction-policies/companies/lookup');
		return result;
	}
	
	async getAPIRestrictionServiceAccounts(companyId) {	
		var result = await this.makeGETRequest('/api/resource/api-restriction-policies/service-accounts/' + companyId + '/lookup');
		return result;
	}	
	
	async saveAPIRestrictions(policy, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/api-restriction-policies/' + policy.policyId, policy);
		} else {
			saved = await this.makePOSTRequest('/api/resource/api-restriction-policies', policy);
		}
		return saved;
	}	
		
	//api service account
	async getAPIServiceAccounts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/service-accounts' + params);		
		return data;
	}	
	
	async getAPIServiceAccount(username) {	
		var result = await this.makePUTRequest('/api/resource/service-accounts/' + username);
		return result;
	}		
	
	async saveAPIServiceAccount(account, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/service-accounts/' + account.username, account);
		} else {
			saved = await this.makePOSTRequest('/api/resource/service-accounts', account);
		}
		return saved;
	}	
	
	async activateServiceAccount(username) {	
		var result = await this.makePUTRequest('/api/resource/service-accounts/' + username + '/activate');
		return result;
	}	

	async inactivateServiceAccount(username) {	
		var result = await this.makePUTRequest('/api/resource/service-accounts/' + username + '/inactivate');
		return result;
	}
	
	async deleteServiceAccount(username) {		
		var result = await this.makeDELETERequest('/api/resource/service-accounts/' + username);		
		return result;
	}		
	
	//api tracking
	async loadAPIEvents(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var events = await this.makeGETRequest("/api/resource/api-trackings");
		return events;
	}
	
	exportAPIEvents(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		this.downloadFile('/api/resource/api-trackings/export' + params);		
	};
		
	//web hooks
	async getWebhooks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/webhooks' + params);		
		return data;
	}

	exportWebhooks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/webhooks/export' + params);
	}
	
	async getWebhook(webHookId) {	
		var result = await this.makeGETRequest('/api/resource/webhooks/' + webHookId);
		return result;
	}		
	
	async getWebhookDetails(webHookId) {	
		var result = await this.makeGETRequest('/api/resource/webhooks/' + webHookId + '/details');
		return result;
	}	
	
	async saveWebhooks(webHook, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/webhooks/' + webHook.webHookId, webHook);
		} else {
			saved = await this.makePOSTRequest('/api/resource/webhooks', webHook);
		}
		return saved;
	}	
	
	async activateWebhooks(webHookId) {	
		var result = await this.makePUTRequest('/api/resource/webhooks/' + webHookId + '/activate');
		return result;
	}	

	async inactivateWebhooks(webHookId) {	
		var result = await this.makePUTRequest('/api/resource/webhooks/' + webHookId + '/inactivate');
		return result;
	}
	
	async deleteWebhooks(webHookId) {		
		var result = await this.makeDELETERequest('/api/resource/webhooks/' + webHookId);		
		return result;
	}		
	
	async getAutoUnits(companyId) {
		var data = await this.makeGETRequest('/api/resource/api-restriction-policies/' + companyId + '/auto-units');		
		return data;
	}	
	
	async getDataFilters(companyId) {
		var data = await this.makeGETRequest('/api/resource/api-restriction-policies/' + companyId + '/data-filters');		
		return data;
	}
	
	async getGPSFilters(companyId) {
		var data = await this.makeGETRequest('/api/resource/api-restriction-policies/' + companyId + '/gps-filtering-rules');		
		return data;
	}
	
	async getUnitMatchingRules(companyId) {
		var data = await this.makeGETRequest('/api/resource/api-restriction-policies/' + companyId + '/unit-matching-rules');		
		return data;
	}	
	
	//data Buffers
	async getBuffers(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/api-data-buffers/' + params);		
		return data;
	}		
	
	async downloadBuffer(bufferId) {	
		this.downloadFile('/api/resource/api-data-buffers/' + bufferId + '/download');				
	}	

	async flushBuffer(bufferId) {	
		var result = await this.makePUTRequest('/api/resource/api-data-buffers/' + bufferId + '/flush');
		return result;
	}
	
	async deleteBuffer(bufferId) {		
		var result = await this.makeDELETERequest('/api/resource/api-data-buffers/' + bufferId);		
		return result;
	}	
	
};
